export default {
      id: "ensoleille-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ensoleille-usage",
      toString: function () {
        return this.url;
      }
    }